import LayoutComponent from './layout/layout.component';
import Routes from "./routes/routes";

export const App = () => {
  return (
        <LayoutComponent title="Administrador">
          <Routes />
        </LayoutComponent>
  );
}


